import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useController } from 'pages/Meetings/hooks/useController';

import Footer from 'components/atom/Footer';
import HeaderContent from 'components/molecule/HeaderContent';

import ContentMeeting from './components/ContentMeeting';
import { Container } from './styles';

const InvitationDetails: React.FC = () => {
  const { t } = useTranslation();

  const { typeInvitation, setPageActive } = useController();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container>
      <HeaderContent
        title={
          typeInvitation === 'received'
            ? `${t('meetings:navigation.invitations')}`
            : `${t('meetings:meeting.title')}`
        }
        onClose={() => setPageActive('schedule')}
      />

      <ContentMeeting />

      <Footer />
    </Container>
  );
};

export default InvitationDetails;
